import React, { createContext, useState, useContext, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [operator, setOperator] = useState(null);
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Load user from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedPhone = localStorage.getItem('phone');
    const storedCountryCode = localStorage.getItem('country_code');
    const storedOperator = localStorage.getItem('operator');

    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error parsing stored user data:', error);
        localStorage.removeItem('user');
      }
    }

    if (storedPhone) setPhone(storedPhone);
    if (storedCountryCode) setCountryCode(storedCountryCode);
    if (storedOperator) {
      try {
        setOperator(JSON.parse(storedOperator));
      } catch (error) {
        console.error('Error parsing stored operator data:', error);
      }
    }
  }, []);

  const login = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
    localStorage.removeItem('phone');
    localStorage.removeItem('country_code');
  };

  const value = {
    phone,
    setPhone,
    countryCode,
    setCountryCode,
    operator,
    setOperator,
    user,
    setUser,
    isAuthenticated,
    setIsAuthenticated,
    login,
    logout
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use the UserContext
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
